export const LocationWithAssetTree = {
    value: 'LOCATION_WITH_ASSET_TREE',
    name: 'Location With Asset Tree',
};
export const LocationTree = {
    value: 'LOCATION_TREE',
    name: 'Location Tree',
};
const Basic = [LocationWithAssetTree, LocationTree];
const BasicByValue = Basic.reduce((hash, status) => {
    hash[status.value] = status;
    return hash;
}, {});
export default {
    Basic,
    BasicByValue,
};
